if (!customElements.get('fs-product-experience')) {
  customElements.define('fs-product-experience', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.closest('product-info')?.addEventListener('click', event => {
        const link = event.target.closest('[data-fs-details-link]');
        if (!link) return;
        const details = this.closest('product-info').querySelector('.fs-product-details details');
        if (!details) return;
        event.preventDefault();
        details.open = true;
        details.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        details.querySelector('summary').focus({preventScroll: true});
      }, {signal: this.abort.signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
  });
}
